import { Button, Divider, Stack, Text } from 'shell/components';

const DividerDemo = () => {
    return (
        <>
            <Text variant={'sh1'}>Divider</Text>
            <Stack divider={<Divider />} spacing={2}>
                <Button>Top</Button>
                <Button>Bottom</Button>
            </Stack>
            <Stack direction={'row'} divider={<Divider orientation={'vertical'} />} spacing={2}>
                <Button>Left</Button>
                <Button>Right</Button>
            </Stack>
        </>
    );
};

export default DividerDemo;
